
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1414Dialog extends Serenity.EntityDialog<Report_1414Row, any> {
        protected getFormKey() { return Report_1414Form.formKey; }
        protected getIdProperty() { return Report_1414Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1414Row.localTextPrefix; }
        protected getNameProperty() { return Report_1414Row.nameProperty; }
        protected getService() { return Report_1414Service.baseUrl; }
        protected getDeletePermission() { return Report_1414Row.deletePermission; }
        protected getInsertPermission() { return Report_1414Row.insertPermission; }
        protected getUpdatePermission() { return Report_1414Row.updatePermission; }

        protected form = new Report_1414Form(this.idPrefix);

    }
}